import { GET_CONSTANT_VALUE_LIST } from "@/graphql/queries/constant-value-list";

import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";
import orderBy from "lodash/orderBy";

const useConstantValueList = (constantType: ConstantValueType = "WHOAREWE") => {
  const {
    data: constantValue,
    error,
    loading,
  } = useQuery(GET_CONSTANT_VALUE_LIST, {
    variables: {
      constantType: constantType,
    },
  });

  const data = useMemo(() => {
    if (constantValue) {
      return orderBy(
        constantValue.constantValueByConstant,
        ["id"],
        ["desc"]
      ).map((item) => ({
        value: item.id,
        label: item.name,
      }));
    }
    return [];
  }, [constantValue]);

  return { error, loading, data };
};

export default useConstantValueList;
